export default "__VITE_ASSET__bx4LFDAf__"